import { render } from "./SlideLayer.vue?vue&type=template&id=4ad35262"
import script from "./SlideLayer.vue?vue&type=script&lang=js"
export * from "./SlideLayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__